var $d3b9b386d3cfbc16$exports = {};
$d3b9b386d3cfbc16$exports = {
    "clear": `Rensa`,
    "invalid": `(ogiltigt)`,
    "loading": `L\xe4ser in...`,
    "noResults": `Inga resultat`,
    "valid": `(giltig)`
};


export {$d3b9b386d3cfbc16$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
